// imports
import WCarousel from './WCarousel';
// import Carousel from 'minsky-kit/js/components/Carousel';

// class definition
export default class HeroCarousel extends WCarousel {
    // constructor
    constructor (args = {}, objectName = 'HeroCarousel') {
        args.debug = args.debug || false;

        args.settings = {
            loop:         true,
            spaceBetween: 0,
            autoplay:     {
                delay: 5000,
            },
        };

        // super
        super(args, objectName);

        // if (Drupal.drimage) {
        //     Drupal.drimage.init(this.$el);

        //     setTimeout(() => {
        //         this.$el.querySelector('.swiper-slide-duplicate').forEach(($item) => Drupal.drimage.init($item));
        //     }, 100);
        // }

        this.navigation = true;
    }

    // methods
    destroy () {
        // super destroy
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
